module.exports = __webpack_public_path__ + "static/media/usuario.88bc4439.svg";